<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="800">
    <v-card>
        <v-card-title>
            ADD SUPPLY
        </v-card-title>
        <v-card-text>
            <v-autocomplete 
            filled
            outlined
            dense
            v-model="supplier"
            :items="suppliers"
            item-text="name"
            item-value="id"
            return-object
            color="success"
            label="Fishcar"
            />
             <v-autocomplete 
            filled
            outlined
            dense
            v-model="kind"
            :items="kinds"
            item-text="name"
            item-value="id"
            return-object
            color="success"
            label="Kind of fish"
            />
            <p><v-btn color="info" block rounded @click="addToList()">ADD TO LIST</v-btn></p>
      
        
    <v-list subheader>
      <v-subheader>Listed<v-divider class="ml-2"/></v-subheader>

      <v-list-item
       v-for="(item, i) in supplies"
        :key="i"
      >
      

        <v-list-item-content>
          <v-list-item-title class="caption"> <v-icon @click="removeItem(i)" small left color="error">mdi-trash-can</v-icon>{{item.name}}  <small> {{item.descrition}}</small></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
        <v-divider/>
        </v-card-text>
         
        <v-card-actions>
            
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded depressed  @click="validate()"><v-icon small left>mdi-check</v-icon>{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    kinds: {
        type: Array,
        default: ()=>{ return [] }
    },
     suppliers: {
        type: Array,
        default: ()=>{ return [] }
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      supplies: [],
      supplier:{},
      kind: {},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "Confirm"
         else 
            return "SAVE"
      }
  },
  watch: {
    show () {
      if (this.show == false) {
        this.supplies =[]
        this.supplier = {}
        this.kind = {}
      } 
    }
  },
  methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText']),
      validate () {
      this.emitToParent("new")
      },
    emitToParent (action) {
      this.$emit('DialogEvent', {action: action, supplies:this.supplies})
    },
    removeItem(index){
        this.supplies.splice(index,1)
    },
    showAlert(color, message) {
        this.setAlertText(message)
            this.setAlertColor(color)
            this.setAlert(true)
    },
    addToList() {
        if(this.supplier.id == null || this.supplier.id == undefined) {
            this.showAlert('error','Please select Fishcar!' )
            return
        }
        if(this.kind.id == null || this.kind.id == undefined) {
          this.showAlert('error','Please select fish!' )
            return
        }
        var entry ={}
        entry.name = this.kind.name
        entry.description = this.kind.description
        entry.supplier = this.supplier.id
        entry.category = this.kind.id
        entry.status = 'available'
        this.supplies.push(entry)
        this.kind = {}
    }
  }
}
</script>
